

















import { Component, Vue } from 'vue-property-decorator'
import { BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption } from 'bootstrap-vue';
import OperationFilterOptions from '@/types/OperationFilterOptions';

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise
    }
})
export default class ClientFilter extends Vue {
    filter: OperationFilterOptions = {
        id: null
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.id = null;
        }
        this.$emit('filter-list', this.filter);
    }
}
